const encode = (data) => {
    if (data === undefined) {
        return '';
    }
    return Object
        .entries(data)
        .map(([key, value]) => `${key}=${JSON.stringify(value)}`)
        .join('&');
};
export const decode = (hash) => {
    if (!hash.includes('?')) {
        return {};
    }
    const [, QUERY] = hash.split('?');
    const PARAMS = new URLSearchParams(QUERY);
    // eslint-disable-next-line consistent-return
    return Object.fromEntries([...PARAMS.entries()].map(([key, value]) => [key, JSON.parse(value)]));
};
export const openModal = (hash, data) => {
    const HASH = hash.startsWith('#') ? hash : `#${hash}`;
    const DATA = data === undefined ? '' : `?${encode(data)}`;
    const HASH_WITH_DATA = `${HASH}${DATA}`;
    if (window.location.hash === HASH_WITH_DATA) {
        return;
    }
    window.location.hash = HASH_WITH_DATA;
};
export const closeModal = () => {
    window.location.hash = '';
};
